import React, { useState } from 'react'
import MessageInputModal from './bottom-modal-input-message'

const GiftToFriend = (props) => {
    const [showModal, setShowModal] = useState(false)
    const toggleModal = () => {
        setShowModal(!showModal)
    }
   
  return (
    <>
   <img src={process.env.PUBLIC_URL + '/assets/images/icon/gift.png'} className='px-2' style={{height: '45px', cursor:'pointer'}} onClick={() => {
    setShowModal(true)}} />
    <MessageInputModal show = {showModal} toggleModal={toggleModal} data={props?.data} />
   </>
  )
}

export default GiftToFriend